import { EmptyResponse, IMessenger, Symbol } from '@map/core';
import { CloseBrowserMessage } from './CloseBrowserMessage';
import { CloseAllBrowsersMessage } from './CloseAllBrowsersMessage';
import { BrowserModule } from './BrowserModule';
import { IBrowserService } from './IBrowserService';
import { OpenPageMessage } from './OpenPageMessage';
import { OpenExternalPageMessage } from './OpenExternalPageMessage';
import { DownloadMessage } from './DownloadMessage';
import { DeleteAllCookiesMessage } from './DeleteAllCookiesMessage';

/**
 * The standard implementation of the IBrowserService.
 */
export class BrowserService implements IBrowserService {
  constructor(private messenger: IMessenger) {
  }

  /**
   * Close the open page in the browser.
   */
  readonly openPage = (url: string): void => {
    this.messenger.send(new OpenPageMessage(url));
  }

  /**
   * Close the open page in the browser.
   */
  readonly openExternalPage = (url: string): void => {
    this.messenger.send(new OpenExternalPageMessage(url));
  }

  /**
   * Close the open page in the browser.
   */
  readonly closePage = (): void => {
    this.messenger.send(new CloseBrowserMessage());
  }

  /**
   * Close all pages except for the home page.
   */
  readonly closeAllPages = (): void => {
    this.messenger.send(new CloseAllBrowsersMessage());
  }

  /**
   * Download attachment from the given url.
   */
  readonly downloadAttachment = (url: string, mimeType: string, token: string): Promise<EmptyResponse> => {
    return this.messenger.send(new DownloadMessage(url, mimeType, token));
  }

  /**
   * Delete all cookies stored in the secure browser
   */
  readonly deleateAllCookies = (): void => {
    this.messenger.send(new DeleteAllCookiesMessage());
  }

  readonly symbol: Symbol = BrowserModule.serviceSymbol;
}